import ModalComponent from '../../../components/ModalComponent';
import { useGetAllSipClientReasonByLicenseAsync } from '../../../services/SipClientReasonsService/hooks/useMutation';
import { useContext, useEffect, useState } from 'react';
import { ISipClientReasonSimpleProps } from '../../../services/SipClientReasonsService/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../components/TextFieldComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import DropdownComponent from '../../../components/DropdownComponent';
import {
  useGetSipClientHistoryReasonAsync,
  useUpdateSipClientReasonHistoryAsync,
} from '../../../services/SipClientService/hooks/useMutation';
import { ISipClientHistoryReasonDetailsProps } from '../../../services/SipClientService/types';
import { AppContext } from '../../../context/AppContextProvider';

interface SipClientFillingReasonModalProps {
  onClose: (event: any, reason: any) => void;
  isOpen: boolean;
  lastSipClientHistoryId: number;
  isEdit?: boolean;
}

const SipClientFillingReasonModal = ({
  isOpen,
  onClose,
  lastSipClientHistoryId,
  isEdit,
}: SipClientFillingReasonModalProps) => {
  const [reasons, setReasons] = useState<ISipClientReasonSimpleProps[]>([]);
  const { showSnackbar } = useContext(AppContext);
  const [sipClientReason, setSipClientReason] = useState({
    reasonDetails: '',
  } as ISipClientHistoryReasonDetailsProps);

  const { mutateAsync: mutateGetAllSipClientReasonByLicenseAsync } =
    useGetAllSipClientReasonByLicenseAsync();

  const { mutateAsync: mutateUpdateSipClientReasonHistoryAsync } =
    useUpdateSipClientReasonHistoryAsync();

  const { mutateAsync: mutateGetSipClientHistoryReasonAsync } =
    useGetSipClientHistoryReasonAsync();

  const handleUpdateSipClientReason = () => {
    if (!sipClientReason.reasonId) {
      showSnackbar('Selecione o motivo da ligação', 'error');
      return;
    }

    mutateUpdateSipClientReasonHistoryAsync(
      {
        id: lastSipClientHistoryId,
        data: sipClientReason,
      },
      {
        onSuccess: () => {
          showSnackbar('Justificativa salva com sucesso!', 'success');
          setSipClientReason({} as ISipClientHistoryReasonDetailsProps);
          onClose(undefined, undefined);
        },
      },
    );
  };

  useEffect(() => {
    mutateGetAllSipClientReasonByLicenseAsync(undefined).then(setReasons);
  }, []);

  useEffect(() => {
    if (isEdit && lastSipClientHistoryId) {
      mutateGetSipClientHistoryReasonAsync(lastSipClientHistoryId).then(
        setSipClientReason,
      );
    }
  }, [lastSipClientHistoryId, isEdit]);

  return (
    <ModalComponent
      onClose={onClose}
      isOpen={isOpen}
      cardContainerStyle={{ color: 'white' }}
      title={'Motivo da chamada'}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <DropdownComponent
            options={reasons}
            label="Justificativas"
            optionLabel={'description'}
            optionValue={'id'}
            value={sipClientReason.reasonId}
            onChange={(reasonId) =>
              setSipClientReason((oldStt) => ({ ...oldStt, reasonId }))
            }
          />
        </Grid2>

        <Grid2 size={12}>
          <TextFieldComponent
            onChangeText={(reasonDetails) =>
              setSipClientReason((oldStt) => ({ ...oldStt, reasonDetails }))
            }
            value={sipClientReason.reasonDetails}
            label="Mais detalhes da justificativa (opcional)"
          />
        </Grid2>
        <Grid2 size={{ md: 6, xs: 12 }}>
          <ButtonComponent
            fullWidth
            onClick={() => handleUpdateSipClientReason()}
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default SipClientFillingReasonModal;
